// 2_components/search_raventic_dropdown_setup_new.js
// Vendor Raventic search-DROPDOWN integration (test eshop only), v4 SDK: defines
// window.RaventicSearchDropdownConfig and runs Raventic's loader snippet, which
// injects the v4 dropdown SDK. The minified loader IIFE is vendor code, left untouched.

export function init() {
	/* if (!document.body.classList.contains("is-test-eshop") && !document.body.classList.contains("sk")) return; */

	window.RaventicSearchDropdownConfig = {
		elementSelectors: ["#formSearchForm input[type='search']"],
		config: {
			locale: window.NAT.raventic[window.NAT.lang].locale,
			apiKey: window.NAT.raventic[window.NAT.lang].apiKey,
			bestsellersApiKey: window.NAT.raventic[window.NAT.lang].bestsellersApiKey,
			currency: window.NAT.raventic[window.NAT.lang].currency,
			priceDecimals: window.NAT.raventic[window.NAT.lang].priceDecimals,

			welcomeMessage: window.NAT.translations("raventicWelcome"),
			recommendedProductsTitle: window.NAT.translations("raventicRecommendedProducts"),
			foundProductsTitle: window.NAT.translations("raventicFoundProducts"),
			foundProductsTitleShort: window.NAT.translations("raventicFoundProducts"),
			noResultsFoundMessage: window.NAT.translations("raventicNoResults"),
			searchingForMessage: window.NAT.translations("raventicSearchingFor"),
			wouldYouLikeToSearchForMessage: window.NAT.translations("raventicWouldYouSearchFor"),
			analyticsEventsTarget: "dataLayer",
			zIndex: 9999,

			queryParameterName: "string",
			buttonTypeParameterName: "button-type",
			buttonLabelParameterName: "button-text",
			buttonStyleParameterName: "button-style",
			defaultButtonLabel: window.NAT.translations("raventicAddToCart"),
			cartConfig: {
				type: "NoActionCart",
			},

			submitUrl: window.NAT.raventic[window.NAT.lang].submitUrl,

			disableDefaultStyles: true,

			customStyles: ``,
			customPageStyles: ``,

			priceParameterName: "_price",
			salePriceParameterName: "_sale-price",

			individualParameters: [
				{
					parameterName: "SHORT_DESCRIPTION",
					title: window.NAT.translations("raventicParamDescription"),
				},
				/* 				{
					parameterName: "RATING_AVG",
					title: "Hodnocení",
				},
				{
					parameterName: "RATING_TOTAL",
					title: "Počet recenzí",
				}, */
				/* 	{
					parameterName: "IMGURL_ALTERNATIVE",
					title: "Alternativní obrázek",
				}, */
				/* 	{
					parameterName: "STOCK_AMOUNT",
					title: "Skladem",
				}, */
			],

			showAllMessage: window.NAT.translations("raventicShowAll"),

			content: [
				{
					type: "categories_feed",
					title: window.NAT.translations("raventicCategoriesTitle"),
				},
				/* 	{
					type: "brands",
					title: "Značky",
				}, */
				/* 	{
					type: "articles",
					title: window.NAT.translations("raventicArticlesTitle"),
				}, */
			],
		},
		onOpen: handleOpen,
		onProductClick: handleProductClick,
		resultHandler: handleResult,
		onClose: handleClose,
		runABTest: false,
	};

	// Vendor Raventic v4 loader — reads window.RaventicSearchDropdownConfig, wires the
	// click-capture machinery, and injects .../semsearch/v4/dropdown.min.js. Left
	// exactly as provided by Raventic.
	!(function () {
		const e = window.RaventicSearchDropdownConfig;
		if (!e)
			return void console.error(
				"RaventicSearchDropdownConfig is not defined. Please set window.RaventicSearchDropdownConfig before loading this script.",
			);
		const {
			elementSelectors: t,
			config: n,
			onOpen: o,
			onProductClick: r,
			errorHandler: a,
			resultHandler: c,
			eventPusher: i,
			onClose: s,
			onContentClick: d,
			runABTest: l,
		} = e;
		if (l) {
			const e = "search_dropdown",
				t = "RaventicSearchIntegrationTest";
			void 0 === window.dataLayer && (window.dataLayer = []);
			const n = "_rvn_ab",
				o = "0",
				r = "1";
			let a = null;
			try {
				a = window.localStorage.getItem(n);
			} catch {
				a = document.cookie
					.split("; ")
					.find((e) => e.startsWith(n + "="))
					?.split("=")[1];
			}
			variant = a === o || a === r ? a : Math.random() < 0.5 ? o : r;
			try {
				window.localStorage.setItem(n, variant);
			} catch {}
			if (
				((document.cookie = `${n}=${variant}; domain=${location.hostname}; path=/; max-age=${365 * 86400}; sameSite=Lax`),
				t &&
					window.dataLayer.push({ event: t, raventic: { search: {}, raventic_variant: variant, raventic_widget: e } }),
				variant === o)
			)
				return;
		}
		const u = { mousedown: !0, mouseup: !1, click: !1, touchstart: !0, touchend: !1 },
			f = { click: !0 },
			v = (e) => {
				(e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation());
			},
			w = new Set(),
			m = new Map(),
			p = (e, t) => {
				const n = t instanceof HTMLInputElement ? t : null,
					o = (t) => {
						(v(t), w.add(e));
					};
				m.set(e, () => {
					for (const [e, r] of Object.entries(n ? u : f)) t.removeEventListener(e, r ? o : v, !0);
				});
				for (const [e, r] of Object.entries(n ? u : f)) t.addEventListener(e, r ? o : v, !0);
			};
		let h = !1;
		const g = Array.isArray(t) ? t : [t];
		for (const e of g) {
			const t = document.querySelector(e);
			t
				? p(e, t)
				: document.addEventListener("DOMContentLoaded", () => {
						if (h) return;
						const t = document.querySelector(e);
						t && p(e, t);
					});
		}
		window.raventicDropDownReady = function (e) {
			if (h) return;
			for (const [, e] of m) e();
			h = !0;
			const t = e(g, n, o, r, a, c, i, s, d);
			for (let e = 0; e < t.length; e++) {
				const n = t[e];
				w.has(g[e]) && n.open();
			}
		};
		const S = document.createElement("script");
		((S.defer = !0), (S.src = "https://sdk.rvndn.com/semsearch/v4/dropdown.min.js"), document.head.appendChild(S));
	})();
}

function handleOpen(instanceId) {
	document.body.classList.add("raventic-search-dropdown-open");
	addDropdownControls();
}

// The SDK renders no close/clear controls on our custom-styled panel, so add our own
// .close-raventic and .clear-raventic buttons into the dropdown body. Runs on the next
// frame because the body may not be in the DOM yet at on-open time; idempotent so
// re-opens don't stack buttons.
function addDropdownControls() {
	requestAnimationFrame(() => {
		const dropdownBody = document.querySelector(".raventic-search-dropdown-body");
		if (!dropdownBody) return;

		if (!dropdownBody.querySelector(".close-raventic")) {
			const closeButton = document.createElement("div");
			closeButton.className = "close-raventic";
			closeButton.setAttribute("role", "button");
			closeButton.setAttribute("tabindex", "0");
			closeButton.setAttribute("aria-label", window.NAT.translations("raventicCloseLabel"));
			closeButton.addEventListener("click", closeRaventicDropdown);
			dropdownBody.appendChild(closeButton);
		}

		const searchFormFieldset = document.querySelector("#formSearchForm fieldset");

		if (!searchFormFieldset.querySelector(".clear-raventic")) {
			const clearButton = document.createElement("div");
			clearButton.className = "clear-raventic";
			clearButton.setAttribute("role", "button");
			clearButton.setAttribute("tabindex", "0");
			clearButton.setAttribute("aria-label", window.NAT.translations("raventicClearLabel"));
			clearButton.addEventListener("click", clearRaventicSearch);
			searchFormFieldset.appendChild(clearButton);
		}
	});
}

// The native search "×" can't clear the field (the vendor loader preventDefault()s
// pointer events on the input), so clear it ourselves and fire an input event so the
// widget re-queries. Selector comes from the config to stay in sync with the widget.
function clearRaventicSearch() {
	const selectors = window.RaventicSearchDropdownConfig?.elementSelectors;
	const selector = Array.isArray(selectors) ? selectors[0] : selectors;
	const input = selector ? document.querySelector(selector) : null;
	if (!input) return;

	// The widget is React-based: assigning input.value directly bypasses React's internal
	// value tracker, so its onChange never fires and the results don't reset. Clear via the
	// native value setter, then dispatch the events so React (and any plain listeners) pick
	// up the empty query and re-render. change/keyup cover non-React or keystroke-debounced
	// listeners too.
	const nativeValueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set;
	if (nativeValueSetter) {
		nativeValueSetter.call(input, "");
	} else {
		input.value = "";
	}

	input.dispatchEvent(new Event("input", { bubbles: true }));
	input.dispatchEvent(new Event("change", { bubbles: true }));
	input.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true }));
	setTimeout(() => {
		input.click();
		input.focus();
	}, 10);
}

// We can't reach the widget instance's close() (it lives in the vendor loader closure),
// so close the way a user would: a pointer event outside the panel (this widget is
// mousedown/touch driven) plus Escape as a fallback. Closing an already-closed widget
// is a no-op, so firing both is safe.
function closeRaventicDropdown() {
	if (window.NAT.media.isMobile) {
		const mobileSearchButton = document.querySelector(".mobile-search-button");
		if (mobileSearchButton) {
			mobileSearchButton.click();
		}
	} else {
		document.body.click();
	}
}

function handleProductClick(product, instanceId, action, source) {
	if (action === "add-to-cart") {
		shoptet.cartShared.addToCart({ productCode: product.id });
	}
}

function handleResult(result, error, reference, instanceId) {
	if (result && !error) {
		document.dispatchEvent(new CustomEvent("RAVENTIC SEARCH RESULTS DROPDOWN LOADED"));
	}
}

function handleClose(instanceId) {
	document.body.classList.remove("raventic-search-dropdown-open");
}
